import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { siteApi } from '../../api/site';
import { queryKeys } from '../queryClient';
import type { SiteInput } from '../../types/domain';

export function useSiteConfig() {
  return useQuery({ queryKey: queryKeys.site, queryFn: () => siteApi.get() });
}

/** Anonymous — site chrome + published nav for public-facing apps. */
export function useSitePublic() {
  return useQuery({
    queryKey: [...queryKeys.site, 'public'],
    queryFn: () => siteApi.getPublic(),
    staleTime: 5 * 60_000,
  });
}

export function useUpdateSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: SiteInput) => siteApi.update(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.site }),
  });
}
